"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_ADS_SANDBOX_PREFIX = exports.API_ADS_PREFIX = exports.API_V1_1_STREAM_PREFIX = exports.API_V1_1_UPLOAD_PREFIX = exports.API_V1_1_PREFIX = exports.API_V2_LABS_PREFIX = exports.API_V2_PREFIX = void 0;
exports.API_V2_PREFIX = 'https://api.x.com/2/';
exports.API_V2_LABS_PREFIX = 'https://api.x.com/labs/2/';
exports.API_V1_1_PREFIX = 'https://api.x.com/1.1/';
exports.API_V1_1_UPLOAD_PREFIX = 'https://upload.x.com/1.1/';
exports.API_V1_1_STREAM_PREFIX = 'https://stream.x.com/1.1/';
exports.API_ADS_PREFIX = 'https://ads-api.x.com/12/';
exports.API_ADS_SANDBOX_PREFIX = 'https://ads-api-sandbox.twitter.com/12/';
